/**
 * 登录密码 RSA-OAEP(SHA-256)，与 express manageLoginRsaSessionService 中 privateDecrypt 对齐。
 *
 * - 正式上线 HTTPS：优先用 Web Crypto（crypto.subtle），无需额外依赖运行时。
 * - 开发阶段 http://IP 等非安全上下文：subtle 不可用，动态加载精简 forge 子模块（见 forgeRsaOaepMinimal.js）。
 */

function pemSpkiToArrayBuffer(pem) {
  const b64 = String(pem || '')
    .replace(/-----BEGIN PUBLIC KEY-----/g, '')
    .replace(/-----END PUBLIC KEY-----/g, '')
    .replace(/\s/g, '');
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

async function encryptWithSubtle(publicKeyPem, password) {
  const subtle = globalThis.crypto && globalThis.crypto.subtle;
  const spki = pemSpkiToArrayBuffer(publicKeyPem);
  const key = await subtle.importKey(
    'spki',
    spki,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    false,
    ['encrypt']
  );
  const data = new TextEncoder().encode(String(password));
  const cipher = await subtle.encrypt({ name: 'RSA-OAEP' }, key, data);
  const u = new Uint8Array(cipher);
  let bin = '';
  for (let i = 0; i < u.length; i += 1) bin += String.fromCharCode(u[i]);
  return btoa(bin);
}

async function encryptWithForge(publicKeyPem, password) {
  const { encryptRsaOaepSha256 } = await import(
    /* webpackChunkName: "forge-rsa-oaep" */ './forgeRsaOaepMinimal.js'
  );
  return encryptRsaOaepSha256(publicKeyPem, password);
}

export async function encryptPasswordRsaOaepSha256(publicKeyPem, password) {
  const subtle = typeof globalThis !== 'undefined' && globalThis.crypto && globalThis.crypto.subtle;
  if (subtle) {
    return encryptWithSubtle(publicKeyPem, password);
  }
  return encryptWithForge(publicKeyPem, password);
}
